function columnLetterToNumber(letter) {
  let num = 0;
  for (let i = 0; i < letter.length; i++) {
    num = num * 26 + (letter.charCodeAt(i) - 64);
  }
  return num;
}

function columnNumberToLetter(num) {
  let letter = "";
  while (num > 0) {
    let mod = (num - 1) % 26;
    letter = String.fromCharCode(65 + mod) + letter;
    num = Math.floor((num - mod) / 26);
  }
  return letter;
}

function applyRangeFormat(
  worksheet,
  startCol,
  endCol,
  startRow,
  endRow,
  numFmt
) {
  const start = columnLetterToNumber(startCol);
  const end = columnLetterToNumber(endCol);

  for (let col = start; col <= end; col++) {
    const colLetter = columnNumberToLetter(col);
    for (let row = startRow; row <= endRow; row++) {
      worksheet.getCell(`${colLetter}${row}`).numFmt = numFmt;
    }
  }
}

export function applyGenusTextFormat(worksheet) {
  const TEXT = "@";

  // ROW 1
  applyRangeFormat(worksheet, "A", "H", 1, 1, TEXT);
  applyRangeFormat(worksheet, "CB", "CD", 1, 1, TEXT);
  applyRangeFormat(worksheet, "CI", "CP", 1, 1, TEXT);
  applyRangeFormat(worksheet, "CR", "CY", 1, 1, TEXT);

  // ROW 2
  applyRangeFormat(worksheet, "A", "H", 2, 2, TEXT);
  applyRangeFormat(worksheet, "CB", "CD", 2, 2, TEXT);
  applyRangeFormat(worksheet, "CI", "CP", 2, 2, TEXT);
  applyRangeFormat(worksheet, "CR", "CY", 2, 2, TEXT);

  // ROW 3 AND BELOW
  applyRangeFormat(worksheet, "B", "I", 3, worksheet.rowCount, TEXT);
  applyRangeFormat(worksheet, "X", "X", 3, worksheet.rowCount, TEXT);
  applyRangeFormat(worksheet, "BL", "BL", 3, worksheet.rowCount, TEXT);
  applyRangeFormat(worksheet, "BN", "BN", 3, worksheet.rowCount, TEXT);
  applyRangeFormat(worksheet, "BZ", "CD", 3, worksheet.rowCount, TEXT);
  applyRangeFormat(worksheet, "CH", "CZ", 3, worksheet.rowCount, TEXT);
}

export function applyGenusNumberFormat(worksheet) {
  const NUMBER = "0";

  // ROW 1
  applyRangeFormat(worksheet, "I", "CA", 1, 1, NUMBER);
  applyRangeFormat(worksheet, "CE", "CH", 1, 1, NUMBER);
  applyRangeFormat(worksheet, "CQ", "CQ", 1, 1, NUMBER);
  applyRangeFormat(worksheet, "CZ", "CZ", 1, 1, NUMBER);
  applyRangeFormat(worksheet, "DA", "DA", 1, 1, NUMBER);

  // ROW 2
  applyRangeFormat(worksheet, "I", "CA", 2, 2, NUMBER);
  applyRangeFormat(worksheet, "CE", "CH", 2, 2, NUMBER);
  applyRangeFormat(worksheet, "CQ", "CQ", 2, 2, NUMBER);
  applyRangeFormat(worksheet, "CZ", "CZ", 2, 2, NUMBER);
  applyRangeFormat(worksheet, "DA", "DA", 2, 2, NUMBER);

  // ROW 3 AND BELOW
  applyRangeFormat(worksheet, "A", "A", 3, worksheet.rowCount, NUMBER);
  applyRangeFormat(worksheet, "J", "W", 3, worksheet.rowCount, NUMBER);
  applyRangeFormat(worksheet, "Y", "BK", 3, worksheet.rowCount, NUMBER);
  applyRangeFormat(worksheet, "BM", "BM", 3, worksheet.rowCount, NUMBER);
  applyRangeFormat(worksheet, "BO", "BY", 3, worksheet.rowCount, NUMBER);
  applyRangeFormat(worksheet, "CE", "CG", 3, worksheet.rowCount, NUMBER);
  applyRangeFormat(worksheet, "DA", "DA", 3, worksheet.rowCount, NUMBER);
}
